import { PriorityKeys } from 'models/rules';
import { getPriorityInfo } from 'utils/worklist';
import classes from 'global.module.css';
import { useTranslation } from 'react-i18next';
import { TableColumnWithIcon } from './Table/TableBody/TableColumnWithIcon';

interface Props {
  priority?: PriorityKeys;
}

const iconSize = 14;

export const PriorityIcon = ({ priority }: Props) => {
  const { icon: Icon, label, color, rotateIcon } = getPriorityInfo(priority);

  const { t } = useTranslation();
  return (
    <TableColumnWithIcon
      icon={<Icon color={color} size={iconSize} className={rotateIcon ? classes.rotateIcon : ''} />}
      label={t(label)}
    />
  );
};
